module.exports = __webpack_public_path__ + "img/cpic.8ece15b7.png";